/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface MeteredUsage
 */
export interface MeteredUsage {
    /**
     *
     * @type {string}
     * @memberof MeteredUsage
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof MeteredUsage
     */
    subscriptionItem: string;
    /**
     * The quantity of the plan to which the customer should be subscribed.
     * @type {number}
     * @memberof MeteredUsage
     */
    quantity: number;
    /**
     * The timestamp for the usage event. This timestamp must be within the current billing period of the subscription of the provided subscription_item.
     * @type {Date}
     * @memberof MeteredUsage
     */
    timestamp?: Date | null;
}

/**
 * Check if a given object implements the MeteredUsage interface.
 */
export function instanceOfMeteredUsage(value: object): value is MeteredUsage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('subscriptionItem' in value) || value['subscriptionItem'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    return true;
}

export function MeteredUsageFromJSON(json: any): MeteredUsage {
    return MeteredUsageFromJSONTyped(json, false);
}

export function MeteredUsageFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeteredUsage {
    if (json == null) {
        return json;
    }
    return {

        'id': json['id'],
        'subscriptionItem': json['subscription_item'],
        'quantity': json['quantity'],
        'timestamp': json['timestamp'] == null ? undefined : (new Date(json['timestamp'])),
    };
}

  export function MeteredUsageToJSON(json: any): MeteredUsage {
      return MeteredUsageToJSONTyped(json, false);
  }

  export function MeteredUsageToJSONTyped(value?: MeteredUsage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'id': value['id'],
        'subscription_item': value['subscriptionItem'],
        'quantity': value['quantity'],
        'timestamp': value['timestamp'] == null ? undefined : ((value['timestamp'] as any).toISOString()),
    };
}
